import { Center, Text } from '@chakra-ui/react';

type SaleTypeDisplayProps = {
  color: string;
  text: string;
};

export const SaleTypeDisplay = (props: SaleTypeDisplayProps) => {
  const { color, text } = props;
  return (
    <Center width={'224px'} height={'46px'} bg={color}>
      <Text fontSize={'md'} fontWeight={'semibold'} color={'white'} whiteSpace='nowrap'>
        {text}
      </Text>
    </Center>
  );
};
